module.exports = __webpack_public_path__ + "img/678CBAE9.47bc2e35.png";